import { createAction, createReducer } from "@reduxjs/toolkit";
import { Tinode } from "tinode-sdk";

const baseChatUrl = process.env.REACT_APP_API_CHAT_URL;
const tinodeApiKey = process.env.REACT_APP_CHAT_API_KEY;

const tinodeConfig = {
  appName: "Megafon Chat",
  host: baseChatUrl,
  apiKey: tinodeApiKey,
  transport: "tcp",
  secure: true,
  persist: true,
};

const chatExstendShow = createAction("chatExstendShow");
const chatExstendHide = createAction("chatExstendHide");

const chatExstend = createReducer(false, (builder) => {
  builder.addCase(chatExstendShow, (state, action) => true);
  builder.addCase(chatExstendHide, (state, action) => false);
});

const tinode = createReducer(new Tinode(tinodeConfig), (builder) => {});

export const actionChat = {
  chatExstendShow,
  chatExstendHide,
};

export const reducerChat = {
  tinode,
  chatExstend,
};
